import React from "react"
import { View } from "react-native"
import BFText from "@/components/standard/BFText"

export function NewBadge() {
  return (
    <View className="bg-teal rounded px-2 py-1 self-start">
      <BFText className="text-midnight-blue font-figtree-extrabold text-[10px] leading-[12px] tracking-[0.01px]">
        NEW
      </BFText>
    </View>
  )
}
